module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fillingDeta.subjectType === 0) ? _c('div', [_c('ep-title', {
    attrs: {
      "title": "备案信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plne-list"
  }, [_c('div', {
    staticClass: "table-item"
  }, [_c('div', {
    staticClass: "plne-state"
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng",
    class: {
      succ: _vm.fillingDeta.subjectFillState === 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('i', [_vm._v("申报单位信息")]), _vm._v(" "), (_vm.fillingDeta.subjectFillState === 2) ? _c('i', [_vm._v("状态：\n              "), _c('span', {
    staticClass: "succ"
  }, [_vm._v("完成")])]) : _c('i', [_vm._v("状态：\n              "), _c('span', {
    staticClass: "err"
  }, [_vm._v("未完成")])])])]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("企业全称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.subjectName))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("中心坐标")]), _vm._v(" "), _c('td', [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.latitude)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("统一社会信用代码")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.code))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "bigImg",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.previewImg(_vm.fillingDeta.imgName)
      }
    }
  }, [_vm._v("查看大图")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("企业法人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.legalPerson))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.phone))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.address))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fillingDeta.zone),
      expression: "fillingDeta.zone"
    }],
    staticClass: "width120"
  }, [_vm._v("所属工业园区")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fillingDeta.zone),
      expression: "fillingDeta.zone"
    }]
  }, [_vm._v(_vm._s(_vm.formatZone(_vm.fillingDeta.zone)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("所属区划类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatRegionType(_vm.fillingDeta.regionType)))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("所属区划")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRegions(_vm.fillingDeta.regions)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-item"
  }, [_c('div', {
    staticClass: "plne-state"
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng",
    class: {
      succ: _vm.fillingDeta.planInfoFillState === 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('i', [_vm._v("预案信息")]), _vm._v(" "), (_vm.fillingDeta.planInfoFillState === 2) ? _c('i', [_vm._v("状态：\n              "), _c('span', {
    staticClass: "succ"
  }, [_vm._v("完成")])]) : _c('i', [_vm._v("状态：\n              "), _c('span', {
    staticClass: "err"
  }, [_vm._v("未完成")])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            风险等级： " + _vm._s(_vm.formatIndustryType(_vm.fillingDeta.riskLevel)) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "span-border"
  }, [_vm._v("风险物质")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fillingDeta.riskyMaterial,
      "border": "",
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "header-align": "center",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "风险物质名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "形态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.formatIndustrystate(scope.row.state)) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storage",
      "label": "储存方式"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "span-border"
  }, [_vm._v("应急物资")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fillingDeta.emergencyMaterial,
      "border": "",
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "header-align": "center",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "function",
      "label": "作用"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "location",
      "label": "放置场所"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "department",
      "label": "使用部门"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "span-border"
  }, [_vm._v("敏感保护目标")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fillingDeta.sensitiveProtection,
      "border": "",
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "header-align": "center",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.formatIndustry(scope.row.type)) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "longitude",
      "label": "经度"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("formatDegree")(scope.row.longitude)) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "latitude",
      "label": "纬度"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("formatDegree")(scope.row.latitude)) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述"
    }
  })], 1)], 1)])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.fillingDeta.subjectType === 1) ? _c('div', [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v("备案流水号： " + _vm._s(_vm.fillingDeta.serialCode))])]), _vm._v(" "), _c('div', {
    staticClass: "plne-list"
  }, [_c('div', {
    staticClass: "table-item"
  }, [_c('div', {
    staticClass: "plne-state"
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng",
    class: {
      succ: _vm.fillingDeta.subjectFillState === 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('i', [_vm._v("申报单位信息")]), _vm._v(" "), (_vm.fillingDeta.subjectFillState === 2) ? _c('i', [_vm._v("状态：\n              "), _c('span', {
    staticClass: "succ"
  }, [_vm._v("完成")])]) : _c('i', [_vm._v("状态：\n              "), _c('span', {
    staticClass: "err"
  }, [_vm._v("未完成")])])])]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("企业全称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.subjectName))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("中心坐标")]), _vm._v(" "), _c('td', [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.latitude)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("单位地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.address))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("所属区划")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRegions(_vm.fillingDeta.regions)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "width200"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.linkMan))]), _vm._v(" "), _c('td', {
    staticClass: "width120"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fillingDeta.phone))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.none_box) ? _c('div', {
    staticClass: "table-item"
  }, [_c('div', {
    staticClass: "plne-state"
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng",
    class: {
      succ: _vm.fillingDeta.planDocFillState === 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('i', [_vm._v("上传备案文件")]), _vm._v(" "), (_vm.fillingDeta.planDocFillState === 2) ? _c('i', [_vm._v("状态：\n          "), _c('span', {
    staticClass: "succ"
  }, [_vm._v("完成")])]) : _c('i', [_vm._v("状态：\n          "), _c('span', {
    staticClass: "err"
  }, [_vm._v("未完成")])])])]), _vm._v(" "), _c('div', {
    staticClass: "filing-file"
  }, [_c('div', {
    staticClass: "file-list"
  }, [_c('ul', _vm._l((_vm.fillingDeta.plandoc), function(item, i) {
    return (_vm.fillingDeta.plandoc) ? _c('li', {
      key: i
    }, [_c('i', {
      staticClass: "iconfont icon icon-dian-copy-copy"
    }), _vm._v(" "), _c('span', {
      staticClass: "ml"
    }, [_vm._v(_vm._s(_vm.formatPlanDoc(item.type)))]), _vm._v(" "), (item.type === 51 || item.type === 1) ? _c('div', {
      staticStyle: {
        "padding-left": "25px"
      }
    }, [(_vm.imgshow == 1) ? _c('img', {
      staticClass: "pdf-box",
      attrs: {
        "src": _vm.showImg(item.id, item.fileName),
        "width": "100",
        "height": "100"
      },
      on: {
        "click": function($event) {
          _vm.previewImg("", true, item.id)
        }
      }
    }) : _vm._e()]) : _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "下载"
      },
      on: {
        "click": function($event) {
          _vm.downloadFiles(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.fileName))])])]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "营业执照",
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "width": "100%"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13af7b1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/weather/fillingInfo.vue
// module id = 1179
// module chunks = 2